import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCectl9CByZO5MXrWcXsCFaHLKhZ_OlQtg",
  authDomain: "meuappexpo.firebaseapp.com",
  projectId: "meuappexpo",
  storageBucket: "meuappexpo.firebasestorage.app",
  messagingSenderId: "751196402545",
  appId: "1:751196402545:web:35ce57ec42a36d5b833cd0",
  measurementId: "G-C07HL1VQPG"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
